export default {
  login: {
    login: '가입하기',
    account: '사용자 이름',
    password: '비밀번호',
    remember: '비밀번호 기억하기',
    forget: '비밀번호를 잊어버려',
    privacy_policy: '개인 정보 정책',
    title: 'STAY 로그인 페이지'
  },
  lang: {
    ko: '한국인',
    ja: '日本語',
    zh: '中文(简)',
    'zh-Hant': '中文(繁)',
    en: 'English'
  },
  tip: {
    emptyData: '데이터가 없습니다',
    login: '계정과 비밀번호는 비워둘 수 없습니다',
    success: '성공적인 운영',
    fail: '작업 실패',
    tip: '힌트',
    logout: '정말로 로그아웃하시겠습니까?',
    yes: '확신하는',
    no: '취소'
  },
  date: {
    week: {
      0: '일요일',
      1: '월요일',
      2: '화요일 ',
      3: '수요일 ',
      4: '목요일 ',
      5: '금요일 ',
      6: '토요일 '
    }
  },
  header: {
    areaGuide: '지역 가이드',
    modelCourses: '모델 코스',
    travelGuide: '여행 가이드',
    tickets: '티켓',
    areaGuideDescription: '모든 지역에는 저마다의 이야기가 있습니다',
    modelCoursesDescription: '모든 여행 스타일을 위한 커스터마이징된 루트',
    travelGuideDescription: '방문자의 실제 경험',
    accessMap: '액세스 맵',
    accessMapDescription: '주요 도시에서 여기까지의 방법',
    accessMapTitle: '주요 도시 접근',
    accessCities: {
      tokyo: {
        name: '도쿄에서',
        description: 'JR・긴테쓰 특급 이용',
        time: '약 3시간'
      },
      kyoto: {
        name: '교토에서',
        description: '긴테쓰 특급 이용',
        time: '약 2시간 30분'
      },
      osaka: {
        name: '오사카에서',
        description: '긴테쓰 특급 이용',
        time: '약 2시간'
      },
      nagoya: {
        name: '나고야에서',
        description: '긴테쓰 특급 이용',
        time: '약 1시간 30분'
      }
    }
  },
  footer: {
    termsOfService: '이용 약관',
    privacyPolicy: '개인정보 보호정책',
    specifiedCommercialTransactions: '특정 상거래법에 따른 표기',
    contact: '문의하기',
    address: '〒517-0011 미에현 도바시 도바 1-2-3',
    copyright: '© 긴키 철도'
  },
  article: {
    aboutTheCourse: '코스 소개',
    author: '저자',
    schedule: '일정',
    recommendedPoints: '추천 포인트',
    home: '홈',
    regionalIntroduction: '지역 소개',
    iseCity: '이세시',
    iseshi: '이세시',
    iseDescription:
      '일본인들의 마음의 고향인 이세 신궁을 중심으로 번영한 역사적인 마을.',
    travelGuide: '여행 가이드',
    iseSightseeingGourmetGuide: '이세 관광 미식 가이드',
    mustSeeSpots: '필수 방문지',
    relatedArticles: '관련 기사',
    touristGuide: '관광 가이드',
    basicGuideToVisitingIseJingu: '이세 신궁 방문 기본 가이드',
    traveler: '여행자',
    showMore: '더 보기'
  },
  home: {
    learnMore: '자세히 보기'
  },
  share: {
    activityCategory: {
      RAILWAY_TICKET: '철도 티켓',
      AIRPORT_TRANSPORTATION: '공항 교통',
      SHINKANSEN: '신칸센',
      EXPRESS_BUS: '고속버스',
      BUS_TOUR: '버스 투어',
      CRUISES: '크루즈',
      RENTAL_CAR: '렌터카',
      CHARTER: '전세',
      ATTRACTION: '어트랙션',
      THEME_PARK: '테마파크',
      MUSEUM_GALLERY: '박물관 / 미술관',
      AQUARIUM_ZOO: '수족관 / 동물원',
      TEMPLES_SHINES: '사찰 / 신사',
      TOWER_BUILDING: '타워 / 건물',
      JAPANESE_RESTAURANT: '일식',
      WESTERN_RESTAURANT: '양식',
      CHINESE_RESTAURANT: '중식',
      OTHER_RESTAURANT: '기타 식당',
      DESSERT_BEVERAGE: '디저트 / 음료',
      SIGHTSEEING_TOUR: '관광 투어',
      MARINE_SPORTS: '해양 스포츠',
      OUTDOOR_ACTIVITIES: '아웃도어',
      ONSEN: '온천',
      SPA_MASSAGE: '스파 / 마사지',
      JAPANESE_CULTURAL_EXPERIENCE: '일본 문화 체험',
      JAPANESE_CRAFT_EXPERIENCE: '일본 공예 체험',
      JAPANESE_COOKING_EXPERIENCE: '일본 요리 체험',
      OTHER_EXPERIENCE: '기타 체험',
      HOTEL: '호텔',
      RYOKAN: '료칸',
      VACATION_RENTAL: '휴가용 임대',
      BUNDLE: '세트',
      PASS: '패스',
      OTHERS: '기타'
    }
  }
};
